import Config from '@app/dev/config/main';
import { DynamicStep } from './pieces/DynamicStep';
import { fieldRegistry } from './constants/fieldRegistry';
import { validateStep } from './constants/validation';

/**
 * Builds the step list entirely from config.
 * Each step in registrationFormSteps declares which fields it contains and their enabled state.
 * To move a field between steps, add, remove, or disable one — only conf.js needs to change.
 */
export const getStepsList = () => {
  const { registrationFormSteps } = Config.registrationFormConfigs;

  return registrationFormSteps.map(({ name, label, fields: configFields = [] }) => {
    const stepFields = configFields
      .map((configField) => {
        const registryField = fieldRegistry[configField.name];
        if (!registryField) return null;
        return {
          ...registryField,
          enabled: configField.enabled ?? true,
          ...(configField.className !== undefined && { className: configField.className }),
        };
      })
      .filter(Boolean);

    return {
      name,
      label,
      step: {
        component: DynamicStep,
        fields: stepFields,
        validate: (form) => validateStep(stepFields, form),
      },
    };
  });
};
